import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DirectDebitPaymentReducer } from '../reducers';

export const selectDirectDebitPaymentFeature = createFeatureSelector<DirectDebitPaymentReducer.DirectDebitPaymentState>(DirectDebitPaymentReducer.featureName);

export const selectDirectDebitPayment = createSelector(selectDirectDebitPaymentFeature, (state: DirectDebitPaymentReducer.DirectDebitPaymentState) => state.item);

export const selectLoadingItem = createSelector(selectDirectDebitPaymentFeature, ({ isLoading }) => isLoading);
